import React from 'react'
import AddServicePlanForm from '../../../../components/ServicePlanManagement/AddServicePlanForm';
import { useQuery } from '@apollo/client';
import { getServicePlans } from '../../../../lib/graphql';
import Loader from '../../../../components/Loader/Loader';

const EditServicePlan = ({ id }) => {
    const { data, loading } = useQuery(getServicePlans, {
        variables: { id: Number(id) },
        fetchPolicy: 'network-only',
        ssr: false,
    });

    if (loading) {
        return <Loader type="text" />;
    }

    const result = data?.getServicePlan?.result;

    const initialValues = {
        ...result,
        dynamicServicePlans: result?.dynamicServicePlans?.length > 0
            ? result.dynamicServicePlans
            : [{
                language: 'en',
                planName: result?.planName,
                description: result?.description,
            }]
    };

    return (
        <AddServicePlanForm
            initialValues={initialValues}
            title="edit"
        />
    );
};

export default EditServicePlan;